
require('babel-polyfill');
var md = require('tfmarkdown');
var $ = require('./scaffold');
var Chart = require('chart.js');

var scroll = require('./scroll');
var calc = require('./calc');

window.equations = '';
window.yearlyEquations = '';
window.currentValues = {};
window.currentFields = {};

location.hash = '';

var fieldTypes = window.fieldTypes = require('./fieldTypes');

var defaultData = exports.defaultData = null;
window.openTab = null;

function isFunction(functionToCheck) {
	var getType = {};
	return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

window.calcTooltips = [];
function Tab(t, tabNumber, tabCount) {
	this.isLoaded = false;
	var tabElement = $.create('div', {class: 'tab', innerText: '▶ '+t.name});
	var tabContent = $.create('div', {class: 'tab-content'});
	var tabButtons = $.create('div', {class: 'tab-buttons'});

	this.open = function() {
		tabElement.innerText = '▼ '+t.name;
		openTab = this;
		if (t.id !== 'home') calc(t.id==='output'?true:false);
		location.hash = t.id;
		setTimeout(() => {
			tabContent.style.display = 'block';
			setTimeout(() => {
				tabContent.style.opacity = '1';
				var elementY = $.getPosition(tabElement)[1];
				if (elementY < document.body.scrollTop) scroll.scrollTo((elementY/2) - 5);
			}, 50);
		}, 500);
		
	};
	this.close = function() {
		tabElement.innerText = '▶ '+t.name;
		tabContent.style.opacity = '0';
		setTimeout(() => {
			tabContent.style.display = 'none';
		}, 500);
	}

	$.on(tabElement, 'click', () => {
		openTab.close();
		this.open();
	});


	$.send(calculatorPath+'config/'+t.id+'.md?'+(new Date()).getTime(), (tabData) => {
		var innerText = md.parse(tabData.responseText, true);
		innerText = innerText.replace(/{{\#([a-zA-Z]+)}}([\s\S]*){{\/\1}}/g, (all, tag, content) => {
			return '<div id="'+tag+'">'+content+'</div>'
		});
		innerText = innerText.replace(/{{tooltip}}([\s\S]*?){{\/tooltip}}/gm, (all, content) => {
			calcTooltips.push(content);
			return '<div class="questionMark" tipNumber="'+(calcTooltips.length-1)+'" onclick="console.log(calcTooltips);alert(calcTooltips[this.getAttribute(\'tipNumber\')]);">?</div>'
		});
		innerText = innerText.replace(/{{([a-zA-Z0-9]+)}}/g, (all, varName) => {
			currentFields[varName] = true;
			if (Array.isArray(fieldTypes[varName])) {
				var options = '';
				for (var opt of fieldTypes[varName]) {
					options += '<option>'+opt+'</option>';
				}
				return '<select id="'+varName+'" value="'+defaultData[varName]+'">'+options+'</select>';
			} else if (isFunction(fieldTypes[varName])) {
				let ft = fieldTypes[varName];
				setTimeout(() => {
					ft(false);
				}, 50);
				return '<input id="'+varName+'" type="checkbox" onclick="fieldTypes.'+varName+'(this.checked)" />';
			} else if (typeof(fieldTypes[varName]) === 'object' && fieldTypes[varName].color) {
				return '<span id="'+varName+'" style="color: '+fieldTypes[varName].color+'">0</span>';
			} else if (typeof(fieldTypes[varName]) === 'object') {
				var bd = fieldTypes[varName];
				return '<input id="'+varName+'" type="button" value="'+bd.text+'" onclick="fieldTypes.'+varName+'.func()" />';
			} else if (varName === 'chart') {
				return '<canvas id="chartHolder"></canvas>';
			} else if (varName === 'chart2') {
				return '<canvas id="chartHolder2"></canvas>';
			} else if (defaultData[varName] === undefined || typeof(defaultData[varName]) === "number") {
				return '<span id="'+varName+'">0</span>';
			} else {
				var defaultValue = defaultData[varName];
				defaultValue = defaultValue !== undefined ? defaultValue : [0,0,100];
				return '<input id="'+varName+'" type="number" value="'+defaultValue[1]+'" onchange="calc()"  />';
			}
		});
		tabContent.innerHTML = innerText;

		if (tabNumber < tabCount-1) {
			var nextButton = $.create('input', {type: 'button', value: 'Next'});
			$.on(nextButton, 'click', function(e) {
				openTab.close();
				tabDict[tabs[tabNumber+1].id].open();
			});
			tabButtons.appendChild(nextButton);
			tabContent.appendChild(tabButtons);
		}

		this.isLoaded = true;
		if (this.onload && openTab === this) this.onload();
	});

	calculatorContainer.appendChild($.create('div', {class: 'tab-holder', children: [tabElement, tabContent]}));
	
	var hashloc = location.hash.replace('#','');
	if (hashloc === t.id) this.open();
}

var tabs = [];
var tabDict = {};

$.on(window, 'hashchange', function() {
	var hashloc = location.hash.replace('#','');
	if (openTab != tabDict[hashloc] && tabDict[hashloc]) {
		openTab.close();
		tabDict[hashloc].open();
	}
});

var p1 = new Promise((resolve, reject) => {
	$.send(calculatorPath+'config/defaults.json?'+(new Date()).getTime(), (dd) => {
		exports.defaultData = defaultData = JSON.parse(dd.responseText);
		resolve();
	});
});
var p2 = new Promise((resolve, reject) => {
	$.send(calculatorPath+'config/math.txt?'+(new Date()).getTime(), (resp) => {
		equations = resp.responseText;
		resolve();
	});
});
var p3 = new Promise((resolve, reject) => {
	$.send(calculatorPath+'config/math-yearly.txt?'+(new Date()).getTime(), (resp) => {
		yearlyEquations = resp.responseText;
		resolve();
	});
});
var p4 = new Promise((resolve, reject) => {
	var cs = $.create('link', {rel: 'stylesheet', type: 'text/css', href: calculatorPath+'style.css', parent: document.head});
	cs.onload = function() {
		resolve();
	};
});

Promise.all([p1, p2, p3, p4]).then(() => {
	$.send(calculatorPath+'config/tabs.json?'+(new Date()).getTime(), (tabList) => {
		tabs = JSON.parse(tabList.responseText);
		var firstTab = null;
		for (var i=0; i<tabs.length; i++) {
			var t = tabs[i];
			var tb = new Tab(t, i, tabs.length);
			tabDict[t.id] = tb;
			if (!firstTab) firstTab = tb;
		}
		if (!openTab) firstTab.open();
	});
});		
